import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { oldGloryBaseUrl } from 'config/apiConfig';
interface CompanyDetails {
    name: string;
    companyCode: string;
    country: string;
    status: string;
    companyId: number;
    default: boolean;
    email: string;
    logoUrl: string;
}
interface PersonalUser {
    name?: string;
    imgUrl?: string;
    username?: string;
}
const initialPersonalSender: PersonalUser = {
    name: '',
    imgUrl: '',
    username: '',
};

export interface RequestMoneyDetailTypes {
    amount?: number;
    code?: number;
    company?: CompanyDetails;
    createdDate?: string;
    currencyCode?: string;
    firstName?: string;
    imgUrl?: string;
    lastName?: string;
    msg?: string;
    requestMoneyId?: number;
    statusCode?: string;
    statusDate?: string;
    subject?: string;
    companySender?: CompanyDetails;
    user?: PersonalUser;
    userSender?: PersonalUser;
    name?: string;
    logoUrl?: string;
    username?: string;
    confirmationCode?: number;
    transactionDateTime?: string;
    balance?: number;
    note?: string;
    status?: string;
    myRole?: string;
}
const initialCompanyDetails: CompanyDetails = {
    name: '',
    companyCode: '',
    country: '',
    status: '',
    companyId: 0,
    default: false,
    email: '',
    logoUrl: '',
};

const initialRequestMoneyDetail: RequestMoneyDetailTypes = {
    amount: 0,
    code: 0,
    company: initialCompanyDetails,
    createdDate: '',
    currencyCode: '',
    firstName: '',
    imgUrl: '',
    lastName: '',
    msg: '',
    myRole: '',
    requestMoneyId: 0,
    status: '',
    statusCode: '',
    statusDate: '',
    subject: '',
    username: '',
    companySender: initialCompanyDetails,
    user: initialPersonalSender,
    userSender: initialPersonalSender,
    name: '',
    logoUrl: '',
    confirmationCode: 0,
    transactionDateTime: '',
    balance: 0,
    note: '',
};

interface typesOfRequestMoney {
    requestMoneyDetail: RequestMoneyDetailTypes;
    loading: boolean;
    error: string | null;
}

const initialState: typesOfRequestMoney = {
    requestMoneyDetail: initialRequestMoneyDetail,
    loading: false,
    error: null,
};
export const requestUpdateStatus = createAsyncThunk(
    'requestUpdateStatus/updateStatus',
    async (
        {
            requestId,
            newStatus,
            isBusiness,
            moneyContainerId,
        }: { requestId: string | number; newStatus: string; isBusiness: boolean; moneyContainerId?: number },
        { getState }
    ) => {
        const state: any = getState();
        const { user } = state || {};
        const { defaultContainerId } = user || 0;
        const payload: any = {
            requestId,
            newStatus,
            svaId: moneyContainerId || defaultContainerId,
            senderIsBusiness: true,
            receiverIsBusiness: true,
        };
        if (isBusiness) {
            payload.senderIsBusiness = false;
            payload.receiverIsBusiness = false;
        }
        const res: any = await client.post(`${oldGloryBaseUrl}/request/updateStatus`, { ...payload });
        return res;
    }
);
export const fetchRequestMoneyDetail = createAsyncThunk('requestMoneyDetail/fetchRequestMoneyDetail', async (requestId: string) => {
    const res: any = await client.get(`/request/V2/${requestId}`);
    return res;
});

const requestMoneyDetailSlice = createSlice({
    name: 'requestMoneyList',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchRequestMoneyDetail.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchRequestMoneyDetail.fulfilled, (state, action) => {
            state.loading = false;
            if (!action?.payload) return;
            state.requestMoneyDetail = action?.payload || {};
        });
        builder.addCase(fetchRequestMoneyDetail.rejected, (state) => {
            state.loading = false;
            state.requestMoneyDetail = initialState.requestMoneyDetail;
        });
    },
});

export default requestMoneyDetailSlice.reducer;
